export default "__VITE_ASSET__4bb59efd__"